export { IdDiamondCard1 } from "./IdDiamondCard1";
